<style lang="scss" scoped>
.gift-banner {
    position: relative;
    width: 100%;
    height: 360px;

    &:after {
        content: "";
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            225deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.5) 100%
        );

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    .content {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 0 24px;

        @media (min-width: 1024px) {
            padding: 0 40px;
        }

        .title {
            white-space: nowrap;
            line-height: 1;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .description {
            max-width: 350px;
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="mb-40 d-flex flex-wrap w-100" v-if="title">
            <h3 class="title" v-html="title"></h3>
            <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
        </div>
        <component :is="giftInterface.cta_kind && linkIsValid ? 'a': 'div'" class="d-block position-relative" :href="giftInterface.cta_kind && linkIsValid ? (giftInterface.cta_kind === 'link' ? `/${giftInterface.cta_link}` : route('nl.category',  {'slug': giftInterface.cta_category.slug})) : null">
            <div class="mx-n24 mx-md-0">
                <div class="gift-banner">
                    <img v-if="giftInterface.image" :src="giftInterface.image.url" :alt="giftInterface.title">
                    <div class="content">
                        <h3 v-if="giftInterface.title" class="mb-8 text-white title">{{ giftInterface.title }}</h3>
                        <p v-if="giftInterface.description" class="small text-white font-weight-book description">
                            {{ giftInterface.description }}
                        </p>
                        <button v-if="giftInterface.cta_kind != null && giftInterface.cta_kind != '' && linkIsValid" class="btn btn-accent mt-16 align-self-start" :href="giftInterface.cta_kind === 'link' ? `/${giftInterface.cta_link}` : route('nl.category',  {'slug': giftInterface.cta_category.slug})">{{ giftInterface.cta }} <span v-html="svg('arrow-right', 'arrow-right')" /></button>
                    </div>
                </div>
            </div>
        </component>
    </div>
</template>

<script>
import hasCta from "../mixins/has-cta";

export default {
    name: "pagePart.gift-banner-row",

    mixins: [hasCta],

    props: {
        title: {
            type: String,
            required: false,
        },
        gift: {
            type: Object,
            required: false,
            default: () => {
                return {
                    title: '',
                    description: '',
                    image: '',
                    tags: [],
                    media: [],
                    link: ''
                };
            },
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        alt: {
            type: String,
            required: false,
            default: 'Inspire Your Tribe',
        },
        categoryFilterId: {
            type: Number,
            default: null,
        },
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    computed: {
        giftInterface() {
            if (this.gift.ID != null) {
                let intfc = this.gift.acf;
                intfc.cta_kind = intfc.cta_type;
                intfc.title = this.gift.post_title;
                intfc.id = this.gift.id;

                if (intfc.cta_type == 'category') {
                    let filteredCategory = this.pages.filter(p => p.id == this.gift.acf.cta_category[0]);
                    if (filteredCategory.length > 0) {
                        let slug = filteredCategory[0].slug;
                        intfc.cta_category = {
                            slug: slug
                        };
                    }
                } else {
                    intfc.cta_category = {
                        slug: ''
                    };
                }

                return intfc;
            }
            return this.gift;
        },

        linkIsValid() {
            let intfc = this.giftInterface;

            if (intfc.cta_kind === 'category' && intfc.cta_category && intfc.cta_category.slug != '') {
                return true;
            }

            if (intfc.cta_kind === 'link' && intfc.cta_link != '') {
                return true;
            }

            return false;
        },
    }
}
</script>